import { PageResponse } from "./PageResponse";

interface PagePreviewResponse extends PageResponse {
	previewId: string;
}

export { PagePreviewResponse };
